import React, { useEffect, useRef, useState } from 'react';
import { List } from '@mui/material';
import { bool, node, number } from 'prop-types';

const SelectorsList = ({ loading, skeletonHeight, skeletonComponent, selector }) => {
  const listRef = useRef(null);
  const [selectorsListHeight, setSelectorsListHeight] = useState(0);

  useEffect(() => {
    setSelectorsListHeight(listRef.current.getBoundingClientRect().height);
  }, [listRef]);

  const renderSkeletons = () => {
    const numberOfCardsNeeded = Math.ceil(selectorsListHeight / skeletonHeight);
    const skeletonArray = Array(numberOfCardsNeeded).fill(() => skeletonComponent);
    // eslint-disable-next-line react/no-array-index-key
    return skeletonArray.map((Component, index) => <Component key={`skeletonIndex-${index}`} />);
  };

  return (
    <List
      aria-label="product setup selectors"
      component="div"
      ref={listRef}
      sx={{
        '& div div': {
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none',
        },
        height: '100%',
        overflowY: 'scroll',
        pb: 8,
        pt: 0,
        scrollbarWidth: 'none',
      }}
    >
      {loading ? renderSkeletons() : selector}
    </List>
  );
};

SelectorsList.propTypes = {
  loading: bool.isRequired,
  selector: node,
  skeletonComponent: node,
  skeletonHeight: number.isRequired,
};

SelectorsList.defaultProps = {
  selector: null,
  skeletonComponent: null,
};

export default SelectorsList;
